import { render, staticRenderFns } from "./SingleStepTeam.vue?vue&type=template&id=354fdcdc&scoped=true"
import script from "./SingleStepTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleStepTeam.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleStepTeam.vue?vue&type=style&index=0&id=354fdcdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fdcdc",
  null
  
)

export default component.exports